'use strict'
import $ from 'jquery'
import 'slick-carousel'

export default class PromotedContent {
    constructor(el) {
        this.$el = $(el)
        this.$el.find('.promoted-content-items').slick({
            mobileFirst: true,
            arrows: false,
            dots: true,
            responsive: [{
                breakpoint: 1000,
                settings: 'unslick'
            }]
        })
    }
}